import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={84}
      height={64}
      viewBox="0 0 84 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M29.635 21.088C39.16-.747 70.311-2.464 86 1.976v64.866L0 68v-3.475c21.5-15.058 18.014-16.796 29.635-43.437z"
        fill="rgba(0, 171, 89, 0.05)"
      />
    </Svg>
  );
}

export default SvgComponent;
